
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
export default {
  components: { VueSlickCarousel },
  data() {
    return {
      options: [
        {
          name: "logo",
          label: "Logo",
          type: "image",
        },
      ],
      settings: {
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,

        arrows: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        pauseOnHover: false,
        focusOnSelect: false,
        draggable: false,
        swipeToSlide: false,
        touchMove: false,
        // swipe: false,
        rtl: true,
        cssEase: "linear",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      },
      secondSettings: {
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,

        arrows: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        pauseOnHover: false,
        focusOnSelect: false,
        draggable: false,
        swipeToSlide: false,
        touchMove: false,
        // swipe: false,
        cssEase: "linear",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.$nextTick(function () {
      this.setProps();
    });
    window.addEventListener("resize", this.setProps, {
      passive: true,
    });
  },
  methods: {
    setProps() {
      if (this.$refs.slider1 && this.$refs.slider2) {
        this.$refs.slider1.pause();
        this.$refs.slider2.pause();

        setTimeout(() => {
          this.$refs.slider1._props.rtl = true;

          this.$refs.slider1._props.autoplaySpeed = 0;
          this.$refs.slider2._props.autoplaySpeed = 0;

          this.$refs.slider1._props.speed = 5000;
          this.$refs.slider2._props.speed = 5000;

          this.$refs.slider1.play();
          this.$refs.slider2.play();
        }, 1000);
      }
    },
  },
};
